import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import logo512 from 'assets/logo512.png'

import './layout.sass';

function Logo() {
  return <img height="18px" src={logo512} alt="Erply Wizard" />;
}

function Version() {
  const { REACT_APP_VERSION } = process.env;
  return (
    <div className="app-header-version ml-3" style={{ fontSize: '0.8em' }}>
      <span>Wizard</span>
      <span className="ml-1">{`v${REACT_APP_VERSION}`}</span>
    </div>
  );
}

function AppLayout({ header, main }) {
  return (
    <Container fluid className="app-container">
      <Container fluid className="app-header">
        <Container fluid>
          <Row noGutters>
            <Col className="d-flex align-items-center">
              <Logo />
              <Version />
            </Col>
            <Col className="app-header-content">{header}</Col>
          </Row>
        </Container>
      </Container>
      {main}
    </Container>
  );
}

AppLayout.propTypes = {
  header: PropTypes.node,
  main: PropTypes.node,
};

export default AppLayout;
